import { render, staticRenderFns } from "./privacyText.vue?vue&type=template&id=2db6aec3&"
import script from "./privacyText.vue?vue&type=script&lang=js&"
export * from "./privacyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports